<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        La scuola ENAP è regolarmente iscritta nel registro promotori di attività autofinanziate di Formazione Professionale della regione Campania (Codice Accreditamento 1908/02/12).
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/enapscuola" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/enapscuola/?hl=it" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3     col-md-6 col-sm-6">
                <div _ngcontent-hdv-c247="" class="single-footer-widget"><h3 _ngcontent-hdv-c247="">Sede Torre del Greco</h3><ul _ngcontent-hdv-c247="" class="footer-contact-info"><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-map"></i>Via Marconi, 27<br _ngcontent-hdv-c247="">80059 Torre del Greco (NA) - Italia</li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-phone-call"></i><a _ngcontent-hdv-c247="" href="tel:+390818814675">Telefono: (+39) 081-8814675</a></li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-envelope"></i><a _ngcontent-hdv-c247="" href="mailto:infotorre@enapscuola.com">infotorre@enapscuola.com</a></li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bxs-inbox"></i><a _ngcontent-hdv-c247="" href="tel:+557854578964">Lunedì-Venerdì: 09:00÷18:00<br _ngcontent-hdv-c247="">Sabato: 09:00÷13:00</a></li></ul></div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div _ngcontent-hdv-c247="" class="single-footer-widget"><h3 _ngcontent-hdv-c247="">Sede di C. di Stabia</h3><ul _ngcontent-hdv-c247="" class="footer-contact-info"><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-map"></i>Via Simmaco, 1<br _ngcontent-hdv-c247="">80053 C. Mare di Stabia (NA) - Italia</li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-phone-call"></i><a _ngcontent-hdv-c247="" href="tel:+390818727048">Telefono: (+39) 081-8727048</a></li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bx-envelope"></i><a _ngcontent-hdv-c247="" href="mailto:info@enapscuola.com">info@enapscuola.com</a></li><li _ngcontent-hdv-c247=""><i _ngcontent-hdv-c247="" class="bx bxs-inbox"></i><a _ngcontent-hdv-c247="" href="tel:+557854578964">Lunedì-Venerdì: 09:00÷18:00<br _ngcontent-hdv-c247="">Sabato: 09:00÷13:00</a></li></ul></div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 ENAP Scuola - realizzato da <a target="_blank" href="https://www.discentya.it/" style="color: #ffc221;">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
